/* ========================================================================= */
/* User Agent */
/* ========================================================================= */

/** @type {import("$types/frontend/utilities").UserAgent} */
let USER_AGENT = {};

/**
 * Set global variable USER_AGENT
 * @param {import("$types/frontend/utilities").UserAgent} ua Browser's user agent
 */
export const setUserAgent = (ua) => {
    USER_AGENT = ua;
};

/**
 * Get global variable USER_AGENT
 * @return {import("$types/frontend/utilities").UserAgent}
 */
export default () => {
    return USER_AGENT;
};
